<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/commerce-promo-code"
                :searchArgs="searchArgs">

            <slot slot="afterSearchForm">
                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/commerce-promo-code"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'code'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'user'
                                                    }
                                                ]
                                            }
                                        ]
                                    },

                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'purchaseId'
                                                    }
                                                ]
                                            },
                                            {

                                            }
                                        ]
                                    },
                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },

                                    {
                                        id: 'code',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Code'),
                                        value: true,
                                         export: 'code',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'user',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Utilisateur'),
                                        value: true,
                                         export: 'user',
                                        onChange: function() {}
                                    },

                                    {
                                        id: 'purchaseId',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Numéro de commande'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'orderId',
                                        onChange: function() {}
                                    },

                                ]}"
                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>
    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import ModalExport from '../../../../components/ModalExport'
    import ChartPie from '../../../../components/ChartPie'
    export default {
        name: 'ReportCommercePromoCode',
        components: {
            DynamicList,
            ModalExport,
            ChartPie
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('Code'),
                        key: 'code',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('# commande'),
                        key: 'purchaseId',
                        sortable: false
                    },
                    {
                        label: Core.Definition.getDefinition('Date'),
                        key: 'date',
                        sortable: false
                    },
                    {
                        label: Core.Definition.getDefinition('Utilisateur'),
                        key: 'user',
                        sortable: false
                    },
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'code'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'start'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'end'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'branchId'
                                        }
                                    ]
                                },
                                {},
                                {}
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'code',
                            type: 'text',
                            label: Core.Definition.getDefinition('Code'),
                        },
                        {
                            id: 'user',
                            type: 'text',
                            label: Core.Definition.getDefinition('Utilisateur'),
                        },
                        {
                            id: 'start',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'end',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataCharts: false,
                dataSelectOptions: {}
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
              if(data !== undefined) {
                  if (data.charts !== undefined) {
                      this.dataCharts = data.charts
                  }
                  if (data.selectOptions !== undefined) {
                      this.dataSelectOptions = data.selectOptions
                  }
              }
            },
            clickEdit(value, cell, row) {
                this.$router.push('/commerce/commandes/' + row.purchaseId)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
